var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { withRouter } from "react-router-dom";
import React from "react";
import { connect } from "react-redux";
import Axios from "axios";
import { getLanguageType } from "../../constants/Language";
import Loader from "../Loader";
var Cybersport = /** @class */ (function (_super) {
    __extends(Cybersport, _super);
    function Cybersport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            token: null
        };
        _this.componentDidMount = function () {
            _this.fetchToken();
        };
        _this.componentDidUpdate = function (prevProps) {
            if (prevProps.locale !== _this.props.locale || prevProps.gamblerId !== _this.props.gamblerId) {
                _this.fetchToken();
            }
        };
        _this.fetchToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, gamblerId, locale, _b, data, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, gamblerId = _a.gamblerId, locale = _a.locale;
                        if (!gamblerId)
                            return [2 /*return*/, null];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        this.setState({ isLoading: true });
                        return [4 /*yield*/, Axios({
                                method: "POST",
                                url: "/games-databet",
                                params: {
                                    gamblerId: gamblerId,
                                    locale: locale,
                                    currency: "KZT"
                                }
                            })];
                    case 2:
                        _b = (_c.sent()).data, data = _b === void 0 ? {} : _b;
                        if (data.token) {
                            this.setState({
                                token: data.token
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        this.setState({ isLoading: false });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Cybersport.prototype.render = function () {
        var _a = this.state, isLoading = _a.isLoading, token = _a.token;
        var _b = this.props, locale = _b.locale, darkTheme = _b.darkTheme;
        if (isLoading)
            return _jsx(Loader, {});
        return (_jsx("iframe", { title: "Databet", src: "/htmls/cybersport/?locale=".concat(locale || '', "&theme=").concat(darkTheme ? "dark" : "", "&token=").concat(token || ''), style: {
                zIndex: 1,
                width: "calc(100vw)",
                height: "calc(100dvh - 52px - 45px - 2px)"
            }, sandbox: "allow-scripts allow-same-origin", allowFullScreen: true }));
    };
    return Cybersport;
}(React.Component));
export default withRouter(connect(function (s) {
    var languageId = s.application.get("languageId");
    var darkTheme = s.application.get("darkTheme");
    var _locale = getLanguageType(languageId).name;
    var locale = _locale === 'kk' ? 'ru' : _locale;
    return {
        gamblerId: s.auth.user.gamblerId,
        locale: locale,
        darkTheme: darkTheme,
    };
})(Cybersport));



// WEBPACK FOOTER //
// ./src/components/cybersport/index.jsx